import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import AlertMui from "../core/AlertMui";

const labelStyle = { color: "#707070", fontSize: 12, marginBottom: 1 };
const valueStyle = { fontWeight: 600, fontSize: 13, marginBottom: 8 };
const sectionTitle = { color: "#12b1ee", fontWeight: 600, fontSize: 12, letterSpacing: 1, marginBottom: 6, marginTop: 2 };

function Field({ label, value }) {
  return (
    <Box>
      <Typography style={labelStyle}>{label}</Typography>
      <Typography style={valueStyle}>{value || "—"}</Typography>
    </Box>
  );
}

export default function PaymentDetailsMui({ closeModal, data, onVoid }) {
  const paymentData = data?.paymentData;
  const [loading, setLoading] = useState(false);
  const [voidResult, setVoidResult] = useState(null);
  const [localAlert, setLocalAlert] = useState(null);

  const handleVoid = async () => {
    setLoading(true);
    const result = await onVoid();
    const { responseCode, responseMessage } = result?.response?.data?.data ?? {};
    setVoidResult({ responseCode });
    setLocalAlert({ msg: responseMessage, category: responseCode === 0 ? "success" : "error" });
    setLoading(false);
  };

  return (
    <Box style={{ minWidth: 400, maxWidth: 400, padding: "4px 8px 0" }}>

      <Typography style={sectionTitle}>DOCUMENTO</Typography>
      <Field label="Documento" value={`${data?.documentType} ${data?.documentNumber}`} />
      <Field label="Estado" value={data?.status} />
      <Field label="Método de pago" value={data?.paymentMethod} />

      <Divider style={{ margin: "6px 0 8px" }} />

      <Typography style={sectionTitle}>DETALLE DEL PAGO</Typography>
      {paymentData && Object.entries(paymentData).map(([key, value]) => (
        <Field key={key} label={key} value={value} />
      ))}

      {localAlert && <AlertMui message={localAlert.msg} type={localAlert.category} />}

      <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
        {((!voidResult && data?.canVoidTransaction) || voidResult?.responseCode === -1) && (
          <Button
            color="secondary"
            variant="outlined"
            size="small"
            style={{ marginRight: 8, minWidth: 80 }}
            onClick={handleVoid}
            disabled={loading}
          >
            {loading ? <CircularProgress size={16} color="inherit" /> : "Anular"}
          </Button>
        )}
        <Button onClick={closeModal} color="primary" variant="outlined" size="small">
          Cerrar
        </Button>
      </Box>
    </Box>
  );
}
